import React, { useEffect, useRef, memo } from 'react'
import { Helmet } from 'react-helmet-async'

const getMarketStr = (selectedChannel) => {
   switch (selectedChannel) {
      case 1:
         return "SE"
      case 2:
         return "NO"
      case 3:
         return "DK"
      default:
         return ''
   }
}

export const PrisJaktWidget = ({ artNr, selectedChannelId }) => {
   const refWrapper = useRef()


   useEffect(() => {
      const reloadWidget = () => {
         if (
            window.prisjakt_cheapest &&
            typeof window.prisjakt_cheapest.reload === 'function'
         ) {
            window.prisjakt_cheapest.reload()
         }
      }

      reloadWidget()

      const cleanupFunction = () => {
         const widgetEl = document.getElementsByClassName('prisjakt_cheapest_a')

         if (widgetEl && widgetEl.length) {
            // Keep the last element and remove the rest with a delay
            for (let i = 0; i < widgetEl.length - 1; i++) {
               widgetEl[i].remove()
            }
         }
      }
      // Initial cleanup
      cleanupFunction()

      // Set the initial display to 'none'
      if (refWrapper.current) {
         refWrapper.current.style.display = 'none'
      }

      // Cleanup on selectedArtNr change
      const timeoutId = setTimeout(() => {
         // Delayed cleanup, ensure that is no duplicates before making the widget visible
         cleanupFunction()
         // Change the display to 'block'
         if (refWrapper.current) {
            refWrapper.current.style.display = 'block'
         }
      }, 1000)

      return () => clearTimeout(timeoutId)
   }, [artNr])

   return (
      <>
         <Helmet>
            <script
               async
               defer
               src="https://cdn.pji.nu/b2b/widgets/cheapest/index.js"
            ></script>
         </Helmet>

         <div className="prisjakt-wrapper" ref={refWrapper}>
            {artNr && (
               <div
                  className="prisjakt_cheapest"
                  data-shop="5000"
                  data-product={artNr}
                  data-market={getMarketStr(selectedChannelId)}
                  data-format="medium1"
               ></div>
            )}
         </div>
      </>
   )
}

// export const PrisJaktWidgetInitial = ({ artNr, selectedChannelId }) => {
//    return (
//       <>
//          <Helmet>
//             <script
//                async
//                defer
//                src="https://cdn.pji.nu/b2b/widgets/cheapest/index.js"
//             ></script>
//          </Helmet>

//          {artNr && (
//             <div
//                class="prisjakt_cheapest"
//                data-shop="5000"
//                data-product={artNr}
//                data-market={getMarketStr(selectedChannelId)}
//                data-format="medium1"
//                style={{
//                   marginBottom: '1.25rem',
//                }}
//             ></div>
//          )}
//       </>
//    )
// }
